import { useEntitiesContext } from 'entities/EntitiesExport'

/**
 * WebMCP tools mount when the in-app agent flag is on. Lives in entities/ and
 * reads the store directly because WebMcpProvider is an entities-layer component
 * and cannot import the features/ agent hook. Call from inside an `observer` so
 * flag hydration re-renders.
 */
export const useWebMcpEnabled = (): boolean => {
  const { featureFlagsStore } = useEntitiesContext()
  return featureFlagsStore.web_ai_agent
}
